// extracted by mini-css-extract-plugin
module.exports = {"root":"FullName_root__3uz5L"};